import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { dict, t as translate } from "@/i18n/dict";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hawkam_lang") || "ar");
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    localStorage.setItem("hawkam_lang", lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang, dir]);

  const value = useMemo(
    () => ({
      lang,
      dir,
      setLang,
      toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
      t: (path) => {
        // path like "hero.title" or a node
        if (typeof path === "object" && path !== null) return translate(path, lang);
        if (typeof path !== "string") return "";
        const keys = path.split(".");
        let node = dict;
        for (const k of keys) {
          if (node && typeof node === "object" && k in node) node = node[k];
          else return "";
        }
        return translate(node, lang);
      },
      pick: (obj, key) => {
        // pick localized field: pick(item, "title") -> item.title_ar / item.title_en
        if (!obj) return "";
        return obj[`${key}_${lang}`] || obj[`${key}_en`] || obj[key] || "";
      },
    }),
    [lang, dir]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
